import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { lightGreenColor } from 'js/config/style';

const Container = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;

const CheckIcon = styled(Icon).attrs({ name: 'check' })`
  font-size: 3rem;
  color: ${lightGreenColor};
`;

export default () => (
  <Container>
    <CheckIcon />
  </Container>
);
